import { render, staticRenderFns } from "./fccAlteracoesVagasReservadas.vue?vue&type=template&id=6fadff13"
import script from "./fccAlteracoesVagasReservadas.vue?vue&type=script&lang=js"
export * from "./fccAlteracoesVagasReservadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports